<div class="search-filter">
  <div class="search-filter__body">
    <nz-collapse
      [nzAccordion]="true"
      [nzBordered]="false">

      <nz-collapse-panel
        *ngFor="let panel of panels"
        [nzHeader]="panel.name"
        [nzActive]="panel.active"
        [nzDisabled]="!!errorsOnForm.length"
        [nzExtra]="panel.extraTemplate"
        [hidden]="(!isMobile && !showOperationType) && panel.id === 'operation'">

        <div [ngSwitch]="panel.id">

          <div class="operation-menu operation-menu-filter" 
            *ngIf="isMobile || showOperationType">
            <lps-operation-type-filter *ngSwitchCase="'operation'"
              class="lps-operation-type-filter"
              [panel]="panel"
              [operation]="form.controls.dealType.value"
              [productTypes]="form.controls.productTypes.value"
              (operationChange)="setDealType($event)"
              (productTypesChange)="setFormValue('productTypes', $event)">
            </lps-operation-type-filter>
          </div>

          <lps-property-type-filter
            *ngSwitchCase="'type'"
            [panel]="panel"
            [propertyFilters]="propertyFilters"
            [value]="form.controls.propertyTypes.value"
            (valueChange)="setFormValue('propertyTypes', $event)"
            (cleanValue)="cleanValue('propertyTypes', $event)">
          </lps-property-type-filter>

          <lps-characteristics-type-filter
            *ngSwitchCase="'characteristics'"
            [panel]="panel"
            [value]="form.controls.characteristics.value"
            (valueChange)="setFormValue('characteristics', $event)"
            (cleanValue)="cleanValue('characteristics', $event)">
          </lps-characteristics-type-filter>

          <lps-area-type-filter
            *ngSwitchCase="'area'"
            [panel]="panel"
            [value]="form.controls.area.value"
            (valueChange)="setFormValue('area', $event)"
            (cleanValue)="cleanValue('area', $event)">
          </lps-area-type-filter>

          <lps-value-type-filter
            *ngSwitchCase="'value'"
            [panel]="panel"
            [value]="form.controls.value.value"
            (valueChange)="setFormValue('value', $event)"
            (cleanValue)="cleanValue('value', $event)">
          </lps-value-type-filter>

          <lps-more-type-filter
            *ngSwitchCase="'moreFilters'"
            [panel]="panel"
            [value]="form.controls.moreFilters.value"
            (valueChange)="setFormValue('moreFilters', $event)"
            (cleanValue)="cleanValue('moreFilters', $event)">
          </lps-more-type-filter>

        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>

  <div class="search-filter__footer">

    <button nz-button
      data-testid="btn-apply"
      nzType="primary"
      (click)="emit()"
      [disabled]="!!errorsOnForm.length">
      Aplicar os filtros selecionados
    </button>
  </div>


</div>
